// src/utils/sanitizeHtml.js
// Simple HTML sanitizer using DOMPurify (if available)

export function sanitizeHtml(dirty) {
  // Always escape HTML tags, only allow <br> for newlines
  return String(dirty)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br>");
}
